module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/icons/social/linkedin-default@2x.png?76c3c5d11f3af3bdc0ce8f307aa1cd97";